import React from "react";
import { Box, Container, Image, Heading, Text, Flex } from "@chakra-ui/react";
import founderImg1 from "../../../assets/about/apart/situted.png"; // Replace with actual image

const Foundersmessage = () => {
  return (
    <Box fontFamily={'Archivo'} bg="#005770" color="white" width={'90%'} py={16} textAlign="center" position="relative">
      <Container maxW="container.md">
        {/* Images Section */}
        <Flex justify="center" mb={6} position="relative">
          <Image
            src={founderImg1}
            alt="Founder 1"
            w={{ base: "100px", md: "150px" }}
            transform="rotate(-10deg)"
            position="relative"
            zIndex={2}
            className="fade-in-up"
          />
          <Image
            src={founderImg1}
            alt="Founder 2"
            w={{ base: "100px", md: "150px" }}
            transform="rotate(10deg)"
            position="relative"
            zIndex={1}
            ml={-8}
            className="fade-in-up"
          />
        </Flex>

        {/* Heading */}
        <Heading as="h2" fontSize={{ base: "2xl", md: "3xl" }} color={'#F5F5F5'} fontWeight="bold" mb={4} className="fade-in-up">
          From Our Founders
        </Heading>

        {/* Message Content */}
        <Text fontSize={{ base: "sm", md: "sm" }} maxW="900px" color={'#F5F5F5'} mx="auto" lineHeight="2" className="fade-in-up">
          When We Started This Journey, Our Vision Was Clear: To Build An Agency That Merges
          Creativity, Strategy, And Innovation To Help Brands Stand Out And Succeed. Every Project
          We Undertake Is A Reflection Of Our Commitment To Excellence And Our Belief In The Power
          Of Collaboration.
        </Text>

        <Text fontSize={{ base: "sm", md: "md" }} maxW="900px" mx="auto" mt={4} lineHeight="2" className="fade-in-up">
          We’re Passionate About Delivering Not Just Results, But Transformative Experiences For Our
          Clients. Our Team’s Dedication, Coupled With Your Trust, Is What Drives Us To Push
          Boundaries And Achieve More Every Day. Together, Let’s Turn Your Vision Into A Thriving
          Success Story.
        </Text>
      </Container>
    </Box>
  );
};

export default Foundersmessage;
